import * as React from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { PieChart, PiePlot, PieArc, PieArcLabel } from "@mui/x-charts/PieChart";

export default function CustomPieChart({
 outerData,
 innerData,
 series,
 efficiency
}) {
  
  return (
    <Stack direction={{ xs: "column", md: "row" }} sx={{ width: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>
        <PieChart
          series={series}
          width={400}
          height={400}
          slotProps={{
            legend: { hidden: true },
          }}
        >
          <PiePlot>
            {series.map((serie) => (
              <PieArc key={serie.id} {...serie} />
            ))}
          </PiePlot>
        </PieChart>
      </Box>

      <Stack
        direction="column"
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ width: { xs: "100%", md: "50%" } }}
      >
        <Box>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body1" sx={{ color: "black" }}>
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  width: 12,
                  height: 12,
                  backgroundColor: outerData[0].color,
                  borderRadius: "30%",
                  marginRight: 1,
                }}
              />
              {outerData[0].label}:
            </Typography>
            <Typography variant="body1" sx={{ color: "black" }}>
              {outerData[0].value}
            </Typography>
          </Stack>
          {innerData.map((item, index) => (
            <Stack key={index} direction="row" justifyContent="space-between">
              <Typography variant="body1" sx={{ color: "black" }}>
                <Box
                  component="span"
                  sx={{
                    display: "inline-block",
                    width: 12,
                    height: 12,
                    backgroundColor: item.color,
                    borderRadius: "30%",
                    marginRight: 2,
                  }}
                />
                {item.label}:
              </Typography>
              <Typography variant="body1" sx={{ color: "black" }}>
                 {item.value}
              </Typography>
            </Stack>
          ))}
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body1" sx={{ color: "black" }}>
              Efficiency:
            </Typography>
            <Typography variant="body1" sx={{ color: "black" }}>
              {efficiency}%
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
}
